module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAAJdJREFUOBHtVNsJwCAM1NKNOkYn6KB2PXv5EBLxJPkpbWlA8uASzwuY0m+3KlBrLTjNJM44h9drslknMlHnGabzSLxEwBHsRwdDerNUjyRmOWx5rD67oNf4VOCi4mE4e4lhPOxGkTFmdZnTM2azw3Xv4JBEwsIlBaP7aCkYaVo3GuNpmyC9HlCq/dpd2X43l8fnt3f9L04v2FSJ0tEBje8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/Align/layout_AlignJustify_normal.png
// module id = 308
// module chunks = 0